import SurveyChat from './SurveyChat';
import FixedSurvey from './FixedSurvey';
import { isRTL } from '../../lib/languages';
import { getTranslation } from '../../lib/translations';

// The respondent-facing survey body. The public route renders it for real and the editor renders it as the
// preview, so every design option lives here once. `compact` is the floating launcher panel: no logo, no
// full-page background. `page` is the customer page the embed sits on, stored with the response, and
// `inviteId` is the campaign contact the link was emailed to.
function PublicSurvey({
  survey, preview = false, live = false, workspaceId, compact = false, page, inviteId,
}) {
  const design = survey.design || {};
  const languageCode = survey.settings?.language || 'en';
  const hideBranding = survey.settings?.hideBranding === true;
  const isChat = !survey.mode || survey.mode === 'chat';

  return (
    <div
      className={compact ? 'h-full' : 'min-h-screen'}
      dir={isRTL(languageCode) ? 'rtl' : 'ltr'}
      style={{
        backgroundColor: design.backgroundColor || '#fafbfc',
        fontFamily: `${design.font || 'Nunito'}, Varela Round, sans-serif`,
      }}
    >
      <div className={`mx-auto w-full ${compact ? '' : 'max-w-4xl'}`}>
        {!compact && design.showLogo !== false && (
          <div className="flex justify-center pb-4 pt-8">
            <img
              className="h-16"
              src={design.logo || 'https://cdn.shapo.io/assets/form-placeholder-logo.svg'}
              alt=""
            />
          </div>
        )}

        <div className={compact ? 'px-4 py-4' : 'px-4 py-8 sm:px-6 lg:px-8'}>
          <div className={`mx-auto ${compact ? '' : 'max-w-3xl'}`}>
            {!compact && (
              <div className="mb-8 text-center">
                <h1 className="mb-4 text-3xl font-bold" style={{ color: design.titleColor || '#1f2937' }}>
                  {survey.title}
                </h1>
                {survey.description && (
                  <p className="mb-4 text-lg" style={{ color: design.textColor || '#374151' }}>
                    {survey.description}
                  </p>
                )}
              </div>
            )}

            {isChat ? (
              <SurveyChat
                survey={survey}
                preview={preview}
                live={live}
                workspaceId={workspaceId}
                page={page}
                inviteId={inviteId}
              />
            ) : (
              <FixedSurvey survey={survey} preview={preview} page={page} inviteId={inviteId} />
            )}
          </div>
        </div>

        {!hideBranding && (
          <div className={`text-center ${compact ? 'pb-3' : 'pb-6'}`}>
            <a
              style={{ fontFamily: 'Nunito' }}
              href={'https://shapo.io?ref=survey-branding'}
              target="_blank"
              className="group inline-flex items-center justify-center rounded-full bg-white px-2.5 py-1"
              rel="noopener"
            >
              <span className="text-sm font-medium text-gray-600 group-hover:opacity-75">
                {getTranslation(languageCode, 'poweredBy')}
              </span>
              <img className="ml-1 h-5 w-16 group-hover:opacity-75" src="https://cdn.shapo.io/assets/logo-sm.png" alt="Shapo" />
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default PublicSurvey;
